import React from 'react';
import { styles } from './FeatureCardGrid.css';
import { FeatureCard, FeatureCardProps } from '../FeatureCard/FeatureCard';

export type FeatureCardGridProps = {
  cards: Array<FeatureCardProps>;
};

export const FeatureCardGrid = ({ cards }: FeatureCardGridProps) => {
  return (
    <div className={styles.featureCardGridContainer}>
      {cards.map((card, i) => (
        <FeatureCard key={i} {...card} />
      ))}
    </div>
  );
};
